import { mono, sectionHeaderStyle } from './tokens';
import SkillTile from './SkillTile';

function sortSkills(skills) {
  return [...skills].sort((a, b) => {
    const enabledDelta = (a.enabled === false ? 1 : 0) - (b.enabled === false ? 1 : 0);
    if (enabledDelta) return enabledDelta;
    const officialDelta =
      ((a.is_official || a.is_first_party) ? 0 : 1) -
      ((b.is_official || b.is_first_party) ? 0 : 1);
    if (officialDelta) return officialDelta;
    return (a.name || a.slug || '').localeCompare(b.name || b.slug || '');
  });
}

function GridBody({ list, onSkillClick, minTile = 260 }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${minTile}px, 1fr))`,
        gap: 10,
      }}
    >
      {list.map((skill) => (
        <SkillTile
          key={skill.slug || skill.name}
          skill={skill}
          interactive={Boolean(onSkillClick)}
          onClick={onSkillClick ? () => onSkillClick(skill) : undefined}
        />
      ))}
    </div>
  );
}

export default function SkillGrid({
  skills,
  variant = 'full',
  maxCompact = 6,
  onSkillClick,
  onShowMore,
  emptyLabel = 'No skills yet',
}) {
  const safeSkills = Array.isArray(skills) ? skills : [];
  if (safeSkills.length === 0) {
    return (
      <div
        style={{
          ...mono,
          fontSize: 10,
          color: 'rgba(255,255,255,0.25)',
          padding: '16px 12px',
          textAlign: 'center',
          border: '1px dashed rgba(255,255,255,0.06)',
          borderRadius: 6,
        }}
      >
        {emptyLabel}
      </div>
    );
  }

  const enabled = safeSkills.filter((s) => s.enabled !== false);
  const disabled = safeSkills.filter((s) => s.enabled === false);

  if (variant === 'compact') {
    const sorted = sortSkills(enabled);
    const visible = sorted.slice(0, maxCompact);
    const hidden = sorted.length - visible.length;
    return (
      <div>
        <GridBody list={visible} onSkillClick={onSkillClick} minTile={240} />
        {hidden > 0 && onShowMore ? (
          <button
            onClick={onShowMore}
            style={{
              marginTop: 10,
              ...mono,
              fontSize: 9,
              color: 'rgba(255,255,255,0.5)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'block',
              marginLeft: 'auto',
            }}
          >
            +{hidden} more →
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: 18 }}>
      {enabled.length > 0 && (
        <div>
          <div style={{ ...sectionHeaderStyle, marginBottom: 8 }}>
            Enabled ({enabled.length})
          </div>
          <GridBody list={sortSkills(enabled)} onSkillClick={onSkillClick} />
        </div>
      )}
      {disabled.length > 0 && (
        <div>
          <div style={{ ...sectionHeaderStyle, marginBottom: 8, color: 'rgba(255,255,255,0.3)' }}>
            Disabled ({disabled.length})
          </div>
          <GridBody list={sortSkills(disabled)} onSkillClick={onSkillClick} />
        </div>
      )}
    </div>
  );
}
